import {UserAdsError} from './UserAdsError.js'

export class DeleteUserAdUserAdsError extends UserAdsError {
  static create(message) {
    return new DeleteUserAdUserAdsError(message)
  }
}
